// 获取当前环境的region配置
export function getRegion() {
  // 默认值
  let region = 'cn'

  // 确保在浏览器环境中运行
//   if (typeof window !== 'undefined') {
    // const href = window.location.href

    if (parent?.location?.href.includes('beta') || window?.location?.href.includes('localhost')) {
      region = 'beta'
    } else if (parent?.location?.href.includes('cn')) {
      region = 'cn'
    } else if (parent?.location?.href.includes('hk')) {
      region = 'hk'
    } else if (parent?.location?.href.includes('com')) {
      region = 'com'
    }
//   }

  return region
}

// 导出当前region值
export const region = getRegion()
